module.exports = __webpack_public_path__ + "static/img/LA@3x.e6bf3305.jpg";